/* HINBA — hinba.js */
document.addEventListener('DOMContentLoaded', function () {

  /* Scroll fade-in */
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.07 });
    document.querySelectorAll('.product-card, .equipment-card, .location-card, .category-card, .ws-product-card').forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = `opacity 0.5s ${i * 0.04}s ease, transform 0.5s ${i * 0.04}s ease`;
      obs.observe(el);
    });
  }

  /* Gift denom picker */
  document.querySelectorAll('.gift-denom').forEach(d => {
    d.addEventListener('click', function () {
      document.querySelectorAll('.gift-denom').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
      const amt = document.querySelector('.gift-card-visual__amount');
      if (amt) amt.textContent = this.dataset.value || this.textContent;
    });
  });

  /* Mobile menu */
  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.getElementById('mobile-nav');
  if (toggle && menu) {
    menu.style.display = 'none';
    toggle.addEventListener('click', () => {
      const open = menu.style.display === 'none';
      menu.style.display = open ? 'block' : 'none';
      toggle.setAttribute('aria-expanded', open);
    });
  }

});
